import Vue from 'vue';
import App from './App.vue';
//import Autocomplete from '@trevoreyre/autocomplete-vue';
//import '@trevoreyre/autocomplete-vue/dist/style.css';
//Vue.use(Autocomplete);
//import { applyPolyfills, defineCustomElements } from 'web-social-share';
//https://stenciljs.com/docs/vue
import { applyPolyfills, defineCustomElements } from 'web-social-share/dist/loader';
// Tell Vue to ignore all components defined in the test-components
// package. The regex assumes all components names are prefixed
// 'test'
Vue.config.ignoredElements = [/web-social-\w*/];
// Bind the custom elements to the window object
applyPolyfills().then(() => {
    defineCustomElements();
});
Vue.config.productionTip = false;
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'; // optionally import default styles
Vue.component('vue-draggable-resizable', VueDraggableResizable);
new Vue({
    render: h => h(App)
}).$mount('#app');
